import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Col, Container, Form, FormFeedback, Input, Row, Label, Card, CardBody, CardText, Modal } from 'reactstrap'
import { useFormik } from "formik";
import * as Yup from "yup";
import 'flatpickr/dist/themes/material_green.css';
import Select from 'react-select';
import { isEmpty } from 'lodash';
import { addInquiryRemarks, getInquiryInfomation, updateProductInquiryStatus } from 'helpers/UAM/inquiry.helper';
import moment from 'moment';
import ToastDialog from 'common/ToastDialog';
import ConfirmationModal from 'components/Common/ConfirmationModal';
import { SystemConfigurationContext } from 'context/systemConfigContext';
import PropTypes from 'prop-types';
import "../../assets/scss/custom/pages/_inquiry.scss"
import { formatNumberWithCommas } from '../../common/utility'

const ProductDescription = ({ desc = "" }) => {
    document.title='Edit Registered Dealer Inquiry | DMS'
    let descLength = desc.length

    const [showReadMore, setShowReadMore] = useState(descLength > 150);

    let descToShow = desc.substring(0, 150);
    let descToHide = desc.substring(150, descLength);

    const handleReadMore = () => {
        setShowReadMore(false);
    }

    const handleReadLess = () => {
        setShowReadMore(true);
    }

    return (
        <p>
            {showReadMore ? descToShow : descToShow + descToHide} {" "}
            {showReadMore && (
                <span style={{ cursor: 'pointer' }} className="read-more-link  text-decoration-underline" onClick={handleReadMore}>
                    ...Read More
                </span>
            )}
            {descLength > 150 && (!showReadMore) && (
                <span style={{ cursor: 'pointer' }} className="read-more-link  text-decoration-underline" onClick={handleReadLess}>
                    Read Less
                </span>
            )}
        </p>
    )
}

const PreviewFile = ({ file }) => {

    const previewUrl = `${process.env.REACT_APP_IMAGE_URL}/${file}`

    const handleFilePreview = (url) => {
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = url.split('/').pop();
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(error => {
                setToastInfo({ message: error.message, showToast: true, role: "error" });
            });
    }

    
    return (
        <div className="d-flex align-items-center">
            {file ? (
                <p className="text-success text-xl" onClick={() => handleFilePreview(previewUrl)} style={{
                    cursor: "pointer",
                }}>
                    <i color='#21a946' className="bx bx-download"></i>
                </p>
            ) : (
                <span className="preview-message">-</span>
            )}
        </div>
    );
}



const EditInquiry = () => {
    const navigate = useNavigate()
    let { subInquiryNumber } = useParams();

    if (!isEmpty(subInquiryNumber)) {
        subInquiryNumber = atob(subInquiryNumber)
    }

    const [isBtnLoading, setIsBtnLoading] = useState(false)
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const [inquiryInfo, setInquiryInfo] = useState({});
    const [modalInfo, setModalInfo] = useState({});
    const [confirmationStatus, setConfirmationStatus] = useState(null);
    const { inputMax } = useContext(SystemConfigurationContext)


    const statusOptions = [
        { value: 'win', label: 'Closed (Win)' },
        { value: 'lost', label: 'Closed (Lost)' },
    ]


    const handleFormSubmit = async (values) => {
        setIsBtnLoading(true)
        const bodyData = {
            id: inquiryInfo.id,
            remarks: values.remarks,
        }
        const res = await addInquiryRemarks(bodyData);
        if (res.status) {
            formik.resetForm()
            getInquiryInfo()
        } else {
            setToastInfo({ message: res.message, showToast: true, role: "error" });
        }
        setIsBtnLoading(false)
    }



    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            remarks: '',
        },
        validationSchema: Yup.object({
            remarks: Yup.string().required('Remarks is required'),
        }),
        onSubmit: async (values) => {
            handleFormSubmit(values)
        },
    });


    const setInquiryData = (data) => {
        let file = ''
        const productImages = !isEmpty(data.productImages) ? JSON.parse(data.productImages) : []
        file = !isEmpty(productImages) ? productImages[0] : ''
        const inquiryData = {
            id: data.id,
            productStatus: data.productStatus,
            productDescription: data.productDescription,
            quantity: data.quantity,
            price: data.price,
            deliveryDate: data.deliveryDate,
            dealerName: data.dealer.entityName,
            inquiryNumber: data.inquiryNumber,
            file: file,
            remarks: data.remarks,
        }
        setInquiryInfo(inquiryData)
    }


    async function getInquiryInfo() {
        const res = await getInquiryInfomation({ subInquiryNumber: subInquiryNumber })

        if (res.status) {
            setInquiryData(res.data)
        } else {
            setToastInfo({ message: res.message, showToast: true, role: "error" });
        }
    }

    useEffect(() => {
        getInquiryInfo()
    }, [subInquiryNumber])

    const handleStatus = (option) => {
        setConfirmationStatus(option.value)
    }


    const handleStatusChange = async (status) => {
        const bodyData = {
            subInquiryNumber,
            productStatus: status
        }

        const res = await updateProductInquiryStatus(bodyData);
        if (res.status) {
            setToastInfo({ message: res.message, showToast: true, role: "success" });
            getInquiryInfo()
            setConfirmationStatus(null)
        } else {
            setToastInfo({ message: res.message, showToast: true, role: "error" });
        }
    }

    const bgStyle = {
        background: '#fff',
        boxShadow: '0 1px 4px #344fa0',
        borderRadius: '10px',
        marginTop: '10px'
    }

    const bgStyleReply = {
        background: '#fff',
        boxShadow: '0 1px 4px #ccc',
        borderRadius: '10px',
        marginTop: '10px'
    }

    const handleShowInfo = (data) => {
        setModalInfo(data)
    }
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="page-title-box pb-2 d-flex gap-3 justify-content-between align-items-center mb-1 w-100">

                        <h4 className='mb-0'>Edit Registered Dealer Inquiry</h4>
                        <div>
                            <button
                                className="btn btn-outline-secondary"
                                type="button"
                                onClick={() => navigate(-1)}
                            >
                                Back
                            </button>
                        </div>

                        {/* <i role='button' onClick={() => handleShowInfo(inquiryInfo)} className='bx bx-dots-horizontal-rounded font-24 d-sm-none d-block'></i> */}
                    </div>
                    {/* <hr className='h-10' /> */}


                    <Row className='g-2'>
                        <Col sm={12} md={12} lg={12} xl={12} className='card'>
                            <div className='card-body p-4'>
                                <Row>
                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Inquiry Number</Label>
                                        <p className="">INQ-{inquiryInfo.inquiryNumber}</p>
                                    </div>
                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Sub Inquiry Number</Label>
                                        <p className="">SUBINQ-{subInquiryNumber}</p>
                                    </div>
                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Dealer Name</Label>
                                        <p className="">{inquiryInfo.dealerName}</p>
                                    </div>
                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Expected Delivery Date</Label>
                                        <p className="">{!isEmpty(inquiryInfo.deliveryDate) ? moment(inquiryInfo.deliveryDate).format('MMM DD, YYYY') : ''}</p>
                                    </div>
                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Expected Quantity</Label>
                                        <p className="">{inquiryInfo.quantity}</p>
                                    </div>
                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Expected Price Per Unit</Label>
                                        <p className="">{formatNumberWithCommas(+inquiryInfo.price)}</p>
                                    </div>

                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Download attachment</Label>
                                        <PreviewFile file={inquiryInfo.file} />
                                    </div>
                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Status</Label>
                                        <Select
                                            options={statusOptions}
                                            className='select2-container select2-container--default'
                                            classNamePrefix="select2-selection"
                                            value={statusOptions.find(obj => obj.value === inquiryInfo.productStatus)}
                                            isDisabled={inquiryInfo.productStatus == 'win' || inquiryInfo.productStatus == 'lost'}
                                            onChange={(e) => {
                                                handleStatus(e)
                                            }}
                                        />
                                    </div>
                                    <div className="col-6 mb-3">
                                        <Label className="form-label">Product Description</Label>
                                        <ProductDescription desc={inquiryInfo.productDescription} />
                                    </div>
                                </Row>
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={6} xl={6} className=' card'>
                            <Row className="timeline card-body pb-0">
                                {inquiryInfo.productStatus == 'pending' && <Form className='px-1 mt-2' onSubmit={formik.handleSubmit}>
                                    <div style={{ width: '100%', position: 'relative' }}>
                                        <div style={{ marginBottom: '20px' }}>
                                            <Input
                                                maxLength={inputMax}
                                                value={formik.values.remarks}
                                                type='textarea'
                                                name='remarks'
                                                id='remarks'
                                                placeholder='Enter your query/comments'
                                                onChange={formik.handleChange}
                                                style={{
                                                    borderRadius: '8px',
                                                    resize: 'none',
                                                    width: '100%',
                                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                }}
                                                className={`${formik.touched.remarks && formik.errors.remarks ? 'is-invalid' : ''}`}
                                            />
                                        </div>
                                        <div style={{ position: 'absolute', bottom: '8px', right: '10px' }}>
                                            <Button
                                                disabled={isBtnLoading}
                                                type='submit'
                                                color='success'
                                                style={{ padding: '8px', borderRadius: '50%', width: '40px', height: '40px' }}
                                            >
                                                {isBtnLoading && <span className='spinner-border spinner-border-sm mr-1'></span>}
                                                <i className='bx bx-send'></i>
                                            </Button>

                                        </div>
                                        {formik.touched.remarks && formik.errors.remarks ? (
                                            <FormFeedback className='d-block text-danger' style={{ position: 'absolute', bottom: '-20px', left: '10px' }}>
                                                {formik.errors.remarks}
                                            </FormFeedback>
                                        ) : null}
                                    </div>

                                </Form>}
                                <div style={{
                                    height: inquiryInfo.productStatus == 'pending' ? '450px' : 'auto',
                                    overflowY: 'scroll',
                                }}>
                                    {!isEmpty(inquiryInfo?.remarks) ? inquiryInfo?.remarks.slice(0).reverse().map((item, index) => {
                                        return (
                                            <div className="msger-chat" key={index}>
                                                {item.addedBy !== 'user' ? 
                                            <div className="msg left-msg">
                                         
                                        
                                              <div className="msg-bubble">
                                                <div className="msg-info">
                                                  <div className="msg-info-name">{item.user}</div>
                                                  <div className="msg-info-time"><span>{ moment(item.createdAt).format("MMM DD YYYY, HH:mm A")}</span></div>
                                                </div>
                                                <div className="msg-text">
                                                {item.remarks}
                                                </div>
                                              </div>
                                            </div>
                                        :
                                            <div className="msg right-msg">
                                             
                                        
                                              <div className="msg-bubble">
                                                <div className="msg-info">
                                                  <div className="msg-info-name">{item.user}</div>
                                                  <div className="msg-info-time d-flex flex-column">
                                                    {/* <span>{ moment(item.createdAt).format("MMM DD, YYYY")}</span><span>{ moment(item.createdAt).format("HH:mm A")}</span></div> */}
                                                    <span>{ moment(item.createdAt).format("MMM DD YYYY, HH:mm A")}</span></div>
                                                </div>
                                        
                                                <div className="msg-text">
                                                {item.remarks}
                                                </div>
                                              </div>
                                            </div>
                                            }
                                          </div>
                                     
                                        )
                                    }) :
                                        (
                                            <div className='d-flex align-items-center justify-content-center'>
                                                <p className='mb-0'>No communication found</p>
                                            </div>
                                        )
                                    }
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>
            {
                modalInfo && (
                    <Modal isOpen={!isEmpty(modalInfo)} toggle={() => handleShowInfo({})} centered>
                        <div className="modal-header">
                            <h5 className="modal-title mt-0">Inquiry Information</h5>
                            <button
                                type="button"
                                onClick={() => handleShowInfo({})}
                                className="btn-close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <Row>
                                <div className="col-6 mb-3">
                                    <Label className="form-label">Inquiry Number</Label>
                                    <p className="">INQ-{inquiryInfo.inquiryNumber}</p>
                                </div>
                                <div className="col-6 mb-3">
                                    <Label className="form-label">Sub Inquiry Number</Label>
                                    <p className="">SUBINQ-{subInquiryNumber}</p>
                                </div>
                                <div className="col-6 mb-3">
                                    <Label className="form-label">Dealer Name</Label>
                                    <p className="">{inquiryInfo.dealerName}</p>
                                </div>
                                <div className="col-6 mb-3">
                                    <Label className="form-label">Expected Delivery Date</Label>
                                    <p className="">{!isEmpty(inquiryInfo.deliveryDate) ? moment(inquiryInfo.deliveryDate).format('MMM DD, YYYY') : ''}</p>
                                </div>
                                <div className="col-6 mb-3">
                                    <Label className="form-label">Expected Quantity</Label>
                                    <p className="">{inquiryInfo.quantity}</p>
                                </div>
                                <div className="col-6 mb-3">
                                    <Label className="form-label">Expected Price Per Unit</Label>
                                    <p className="">{inquiryInfo.price}</p>
                                </div>
                                <div className="col-6 mb-3">
                                    <Label className="form-label">Download attachment</Label>
                                    <PreviewFile file={inquiryInfo.file} />
                                </div>
                                <div className="col-6 mb-3">
                                    <Label className="form-label">Status</Label>
                                    <p className="">{inquiryInfo.productStatus}</p>
                                </div>
                                <div className="col-12 mb-3">
                                    <Label className="form-label">Status</Label>
                                    <Select
                                        options={statusOptions}
                                        className='select2-container select2-container--default z-index-9'
                                        classNamePrefix="select2-selection"
                                        value={statusOptions.find(obj => obj.value === inquiryInfo.productStatus)}
                                        isDisabled={inquiryInfo.productStatus == 'win' || inquiryInfo.productStatus == 'lost'}
                                        onChange={(e) => {
                                            handleStatus(e)
                                        }}
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <Label className="form-label">Product Description</Label>
                                    <ProductDescription desc={inquiryInfo.productDescription} />
                                </div>


                            </Row>
                        </div>
                        <div className="modal-footer">
                            <Button
                                type="button"
                                color="secondary"
                                onClick={() => handleShowInfo({})}
                            >
                                Close
                            </Button>
                        </div>
                    </Modal>
                )
            }
            {confirmationStatus && (
                <ConfirmationModal show={confirmationStatus} handleClose={() => setConfirmationStatus(null)} handleSubmit={() => handleStatusChange(confirmationStatus)} text={'Sure, you want to close this inquiry ?'} submitButtonText="Yes" closeButtonText="No" />
            )}
        </React.Fragment>
    )
}

export default EditInquiry